import React, { useState, useEffect } from 'react';
import './Products.css';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { collection, onSnapshot, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

const Products = () => {
  const [products, setProducts] = useState([]); 
  const [categories, setCategories] = useState([]); 
  const [heroImages, setHeroImages] = useState([]); // Hero için resimler
  const [currentHeroIdx, setCurrentHeroIdx] = useState(0); // Şu anki resim sırası
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    // 1. Ürünleri Çek (Gerçek Zamanlı)
    const qProd = query(collection(db, "products"), orderBy("createdAt", "desc"));
    const unsubProd = onSnapshot(qProd, (snapshot) => {
      const allData = snapshot.docs.map(doc => ({ docId: doc.id, ...doc.data() }));
      setProducts(allData);
      
      // Hero için en yeni 5 ürünün resmini ayırıyoruz kanka
      const images = allData.slice(0, 5).map(p => p.img);
      setHeroImages(images);
      
      setLoading(false);
    });

    // 2. Kategorileri Çek
    const unsubCats = onSnapshot(collection(db, "categories"), (snapshot) => {
      setCategories(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => {
      unsubProd();
      unsubCats();
    };
  }, []);

  // Hero Resim Değiştirme Döngüsü (Her 5 saniyede bir)
  useEffect(() => {
    if (heroImages.length > 1) {
      const interval = setInterval(() => {
        setCurrentHeroIdx((prev) => (prev + 1) % heroImages.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [heroImages]);

  const filteredProducts = products.filter(p => {
    const matchesFilter = filter === 'all' || p.cat === filter;
    const matchesSearch = 
      p.name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
      p.id?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="products-page">
      <Navbar />
      
      {/* DINAMIK KAYAN HERO */}
      <div className="products-hero">
        {heroImages.map((img, index) => (
          <div 
            key={index}
            className={`hero-slide ${index === currentHeroIdx ? 'active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="gold-subtitle">Hazineyi Keşfet</span>
          <h1 className="main-title">Tüm <em>Koleksiyon</em></h1>
          <div className="title-line"></div>
        </div>
      </div>

      <div className="products-container">
        <div className="filter-bar">
          <div className="filter-group">
            <button className={filter === 'all' ? 'active' : ''} onClick={() => setFilter('all')}>
              Tümü
            </button>
            {categories.map((cat) => (
              <button 
                key={cat.id}
                className={filter === cat.slug ? 'active' : ''} 
                onClick={() => setFilter(cat.slug)}
              >
                {cat.title}
              </button>
            ))}
          </div>
          
          <div className="search-box">
            <input 
              type="text" 
              placeholder="Ürün veya Kod Ara..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <FaSearch className="search-icon" />
          </div>
        </div>

        {loading ? (
          <div className="no-results">Koleksiyon Hazırlanıyor...</div>
        ) : (
          <div className="products-grid">
            {filteredProducts.map((product) => (
              <Link to={`/urun/${product.id}`} key={product.docId} className={`product-card-premium ${product.size || 'small'}`}>
                <div className="card-image-wrapper">
                  <img src={product.img} alt={product.name} />
                  <div className="card-badge">#{product.id}</div>
                  <div className="card-overlay">
                    <span className="view-text">DETAYI GÖR</span>
                  </div>
                </div>
                <div className="card-info-premium">
                  <h3>{product.name}</h3>
                  <div className="card-footer">
                    <span className="price">{product.price}</span>
                    <div className="line"></div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Products;